import React from 'react';
import { useForm } from "react-hook-form";
import emailjs from '@emailjs/browser';

const ContactFrom = () => {
    const { register, handleSubmit, formState: { errors }, reset } = useForm({
        mode: "onBlur"
    });

    const onSubmit = async (data) => {
        try {
            // emailjs requires the parameters in a specific format
            const templateParams = {
                from_name: data.from_name,
                from_email: data.from_email,
                subject: data.subject,
                message: data.message,
            };

            await emailjs.send('service_0sswgs8', 'template_ioroxvj', templateParams, 'i-8X0198e36XAW_oT');

            // Reset the form after successful submission
            reset();
            alert('Email sent successfully!');
        } catch (error) {
            alert('Oops something went wrong');
            console.error('Error sending email:', error);
        }
    };

    return (
        <div className="contact-form" data-aos="fade-up" data-aos-delay="300">
            {/* Use the handleSubmit from react-hook-form to wrap the onSubmit function */}
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row mb-n6">
                    <div className="col-md-6 col-12 mb-6">
                        <input 
                            type="text" 
                            placeholder="Your Name *" 
                            {...register("from_name", { required: 'Name is required' })} 
                        />
                        {errors.from_name && <p className="error-message">{errors.from_name.message}</p>}
                    </div>
                    <div className="col-md-6 col-12 mb-6">
                        <input 
                            type="email" 
                            placeholder="Email *" 
                            {...register("from_email", {
                                required: 'Email is required',
                                pattern: {
                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                    message: "Invalid email address"
                                }
                            })} 
                        />
                        {errors.from_email && <p className="error-message">{errors.from_email.message}</p>}
                    </div>
                    <div className="col-md-12 col-12 mb-6">
                        <input 
                            type="text" 
                            placeholder="Subject *" 
                            {...register("subject", { required: 'Subject is required' })} 
                        />
                        {errors.subject && <p className="error-message">{errors.subject.message}</p>}
                    </div>
                    <div className="col-12 mb-6">
                        <textarea 
                            placeholder="Message" 
                            {...register("message", { required: 'Message is required' })}
                        ></textarea>
                        {errors.message && <p className="error-message">{errors.message.message}</p>}
                    </div>
                    <div className="col-12 text-center mb-6">
                        <button type="submit" className="btn btn-brand-color btn-hover-secondary">Submit</button>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default ContactFrom;
